<template>
  <div
    class="abstract-content text-body-1 grey--text text--darken-3 px-12 py-8 d-flex justify-center"
  >
    <div class="restrict-width">
      <p v-if="title" class="text-h6 font-weight-bold mb-8">
        <highlightable-content :highlight-terms="searchTerms">
          {{ title }}
        </highlightable-content>
      </p>
      <template v-if="abstractNotEmpty">
        <p v-for="(paragraph, i) in paragraphs" :key="i">
          <highlightable-content :highlight-terms="searchTerms">
            {{ paragraph }}
          </highlightable-content>
        </p>
      </template>
      <v-chip
        v-else
        color="primary"
        small
        @click="$emit('add-abstract')"
      >
        <v-icon left small>add</v-icon> Add Abstract
      </v-chip>
    </div>
  </div>
</template>

<script>
import HighlightableContent from '@/components/Common/HighlightableContent';

export default {
  name: 'AbstractContent',
  components: {
    HighlightableContent,
  },
  props: {
    abstract: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: null,
    },
    searchTerms: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['add-abstract'],
  computed: {
    paragraphs() {
      return this.abstract.split('\n\n');
    },
    abstractNotEmpty() {
      return this.abstract?.trim().length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.abstract-content {
  line-height: 2rem;
}
.restrict-width {
  max-width: 50em;
}
</style>
